import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Box, RadioGroup } from '@workwhile/ui'
import { FiltersSchema } from '../../filtersSchema'
import { approvalStatuses } from './constants'
import { PositionStatusFilter } from 'api/positions/getAllPositions'

export const ApprovalStatusFilter = () => {
  const { watch, setValue } = useFormContext<FiltersSchema>()
  const value = watch('position.status')

  return (
    <Box>
      <RadioGroup
        name="position.status"
        value={value}
        options={approvalStatuses}
        onChange={(next) =>
          setValue('position.status', next as PositionStatusFilter)
        }
      />
    </Box>
  )
}
